import { SettingEnvironmentInformationContainer } from "../";

export const SettingEnvironmentMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingEnvironmentInformationContainer />
    </div>
  );
};
